<template>
  <div ref="googleBtn"></div>
</template>

<script>
export default {
  name: 'google',
  data () {
    return {}
  },
  created () {
    this.initGoogle()
  },
  mounted () {
    window.google.accounts.id.renderButton(
      this.$refs.googleBtn, // Ensure the element exist and it is a div to display correcctly
      { width: '77', size: 'medium' }  // Customization attributes
    )
  },
  methods: {
    initGoogle () {
      const gid = JSON.parse(window.localStorage.getItem('sdkParams') || '{}').gid
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_ID || this.$ENUM.GOOGLE_ACCOUNT_MAP[gid], // Replace with your Google Client ID
        context: 'login',
        ux_mode: 'popup',
        auto_prompt: false,
        callback: response => {
          this.$emit('login', response)
        }
      });
    }
  }
}
</script>

<style lang='scss' scoped >

</style>
